
















































































import {Vue, Component, Prop} from 'vue-property-decorator'
import MobileFriendlyRow from "@/components/MobileFriendlyRow.vue";
import Error from '@/components/Error.vue';
import tippy from "tippy.js";
import EnterpriseId from '@/components/EnterpriseId.vue';
import { Column, Enterprise } from '@/types';

@Component({
  components: {
    MobileFriendlyRow,
    EnterpriseId,
    Error
  }
})

export default class EnterpriseRowMobile extends Vue {

  @Prop({ default: {},  type: Object}) enterprise!: Enterprise;
  @Prop({ default: 0,  type: Number}) index!: number;

  cols:Column[] = [
    {colName: 'enterprise', colStyle:{'flex-grow':1}, colKey:'enterpriseId'}
  ];
  error:string = '';

  async mounted() {
    // nothing here yet
    tippy('[data-tippy-content]');
  }

  getEnrolProfile(ent:Enterprise):string {
  return ent.nwServer && ent.nwServer.actility && ent.nwServer.actility.enrolId ? ent.nwServer.actility.enrolId : 'default';
  }

  getSubscriberId(ent:Enterprise):string {
    return ent.nwServer && ent.nwServer.actility && ent.nwServer.actility.subscriberId ? `${ent.nwServer.actility.subscriberId}` : 'n/a';
  }

  getSupplierId(ent:Enterprise):string {
    return ent.nwServer && ent.nwServer.actility && ent.nwServer.actility.supplierId ? `${ent.nwServer.actility.supplierId}` : 'n/a';
  }

  get canDelete():boolean {
    return this.enterprise.numDevices.direct === 0 && this.enterprise.numDevices.all === 0;
  }
}

